import { formatAudioDuration } from './localAudio.js';

export const PAY_MEDIA_COMPACT_FREE_COUNT = 2;
export const PAY_MEDIA_COMPACT_MAX_ITEMS = 3;

export function normalizePayMediaPriceFields(data = {}, options = {}) {
	const {
		defaultPrice = '9.90',
		defaultButtonText = '立即解锁',
		defaultButtonBg = '#285af9',
		maxPreviewCount = Infinity,
		maxPreviewDuration = Infinity,
	} = options;

	const freePreviewCount = Number(data.freePreviewCount);
	const freePreviewDuration = Number(data.freePreviewDuration);

	return {
		price: data.price ?? defaultPrice,
		currency: data.currency || '¥',
		buttonText: data.buttonText || defaultButtonText,
		buttonBg: data.buttonBg || data.buttonBgStart || defaultButtonBg,
		freePreviewCount: Number.isFinite(freePreviewCount) && freePreviewCount >= 0
			? Math.min(freePreviewCount, maxPreviewCount)
			: 1,
		freePreviewDuration: Number.isFinite(freePreviewDuration) && freePreviewDuration >= 0
			? Math.min(freePreviewDuration, maxPreviewDuration)
			: 30,
	};
}

export function getPayMediaUnlockKey(blockId, prefix) {
	return blockId ? `gedit-${prefix}-${blockId}` : '';
}

export function isPayMediaUnlocked(blockId, prefix) {
	const key = getPayMediaUnlockKey(blockId, prefix);
	if (!key || typeof sessionStorage === 'undefined') return false;
	return sessionStorage.getItem(key) === '1';
}

export function setPayMediaUnlocked(blockId, prefix, unlocked = true) {
	const key = getPayMediaUnlockKey(blockId, prefix);
	if (!key || typeof sessionStorage === 'undefined') return;
	if (unlocked) {
		sessionStorage.setItem(key, '1');
	} else {
		sessionStorage.removeItem(key);
	}
}

export function formatPayPreviewDuration(seconds = 0) {
	return formatAudioDuration(seconds);
}
